"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDummyShiftWarningsAndData = void 0;
const util_1 = require("@app/util");
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const query_1 = __importDefault(require("./query"));
const dummyShiftQuery = (0, graphql_tag_1.default) `query DummyShiftWarningsAndData ($workspaceId: ID!, $data: ShiftData!, $id: ID) {
  dummyShift(workspace: $workspaceId, data: $data, id: $id) {
    userName
    warnings ${query_1.default.EVENT_WARNING}
    pauses { start, duration }
    period { start, end }
    stats {
      date
      nightMinutes
      weekDayMinutes
      weekEndMinutes
      saturdayMinutes
      sundayMinutes
      holidayMinutes
      standByActivityMinutes
      standByMinutes
      overTimeTotalMinutes
      workMinutes
      totalMinutes
    }
    contractId
  }
}`;
const getDummyShiftWarningsAndData = async (args, cb) => {
    const { data, errors } = await (0, apollo_1.query)(dummyShiftQuery, {
        variables: args,
    });
    (0, error_handler_1.processErrors)(errors, `${(0, util_1.t)('SHIFT')} - ${(0, util_1.t)('ERROR')}`);
    if ((0, util_1.isDefined)(errors)) {
        cb?.(errors);
        return;
    }
    cb?.(undefined);
    return data?.dummyShift;
};
exports.getDummyShiftWarningsAndData = getDummyShiftWarningsAndData;
exports.default = exports.getDummyShiftWarningsAndData;
